import React, { type FC, useCallback, useEffect, useState } from "react";
import { Card, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { thunks as strategyThunks } from "src/thunks/strategy-wizard";
import { useDispatch, useSelector } from "src/store";
import { Container } from "@mui/system";
import { useAuth } from "src/hooks/use-auth";
import { useRouter } from "src/hooks/use-router";
import { useParams } from "react-router";

export const Finish: FC = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const user = useAuth();

  const { strategyId } = useParams();
  const steps = useSelector((state) => state.strategyWizard.steps);
  const wizardStep = useSelector((state) => state.strategyWizard.wizardStep);
  const isFinished = useSelector((state) => state.strategyWizard.isFinished);

  const currentStep = steps[wizardStep];
  const currentValue = currentStep?.strategyStep.value;
  //  const currentValue = currentSection.strategyStep.value;
  const [isSaving, setIsSaving] = useState(false);

  const router = useRouter();

  return (
    <Container
      maxWidth="md"
      sx={{
        mt: {
          xs: 2,
          sm: 4,
        },
        mb: 4,
      }}
    >
      <Card
        sx={{
          p: 4,
          mb: 2,
        }}
      >
        Finish
      </Card>
    </Container>
  );
};
